import styled from "@emotion/styled";
import { Chip } from "@mui/material";
import type { ComponentProps } from "react";

import { Icon } from "../../icons";

type Props = ComponentProps<typeof Chip>;

/** The chip a multi-select shows for each of its selected values. */
export const TagChip = (props: Props) => <StyledChip deleteIcon={<Icon icon="times" size={12} />} {...props} />;

const StyledChip = styled(Chip)`
  height: auto;

  gap: 2px;

  padding: 2px 0;
  border-radius: 4px;

  font-size: ${({ theme }) => theme.fontSizeSmall};

  > span {
    padding: 0 8px;

    white-space: nowrap;
  }
`;
